
import React from 'react';

function EmailIcon() {
  return (
    <a href="mailto:example@example.com">
      <i className="fa fa-envelope"></i>
    </a>
  );
}

export default EmailIcon;